import { Input, Modal, Spin, Tabs } from "antd";
import { ModalProps } from "antd/lib/modal";

import React, { useState } from "react";

import RecordListItem from "./Components/RecordListItem";
import style from "./index.module.scss";
import { CustomEmpty, useRequest, findHistoryMsg } from "../../polyfills";
import { getFullMessageText } from "../../Utils/common";

const { Search } = Input;
const { TabPane } = Tabs;

interface RecordsListModalProps extends ModalProps {
    onCancel: () => void;
    sessionUid: string;
}

export default function RecordsListModal({
    onCancel,
    sessionUid,
    ...resProps
}: RecordsListModalProps) {
    const [search, setSearch] = useState("");
    const [type, setType] = useState<"file" | "text" | undefined>(undefined);
    const panes = [
        { title: "全部", key: "1" },
        { title: "文件", key: "2" }
    ];

    const [recordList, { loading }] = useRequest(
        async () => {
            if (sessionUid) {
                return findHistoryMsg(sessionUid, type);
            } else {
                return [];
            }
        },
        {},
        [sessionUid, type]
    );

    const onSearch = (value: string) => {
        setSearch(value);
    };

    function callback(key: string) {
        setType(key === "2" ? "file" : undefined);
    }

    const filterData = recordList
        ?.map(item => {
            if (item.type === "text") {
                return item;
            } else {
                const content = getFullMessageText(item);
                return { ...item, content };
            }
        })
        .filter(filter => {
            return filter.content?.indexOf(search.trim()) !== -1;
        });

    return (
        <Modal
            width={610}
            title={"聊天记录"}
            maskClosable={false}
            className={style.root}
            onCancel={onCancel}
            footer={null}
            {...resProps}>
            <Search
                style={{ marginBottom: 8 }}
                maxLength={200}
                placeholder="请输入私信关键字"
                onSearch={onSearch}
                allowClear
            />

            <Spin spinning={loading}>
                <Tabs defaultActiveKey="1" onChange={callback}>
                    {panes.map(pane => (
                        <TabPane tab={pane.title} key={pane.key}>
                            {filterData?.map(item => (
                                <RecordListItem
                                    item={item}
                                    searchText={search}
                                    clearSearchText={() => setSearch("")}
                                    key={item.guid}
                                    onClose={onCancel}
                                />
                            ))}

                            {filterData?.length === 0 && (
                                <CustomEmpty
                                    description="无数据"
                                    style={{ padding: "100px 0" }}
                                />
                            )}
                        </TabPane>
                    ))}
                </Tabs>
            </Spin>
        </Modal>
    );
}
